import controller from './payment-method.controller';
import './payment-method.less';

export default {
  bindings: {
    bill: '@',
    cardx: '<',
    formReference: '<',
    invoice: '<',
    packet: '<',
    payment: '@',
    subscription: '<',
    mastercardx: '<',
    cardType: '<',
    promocode: '<'
  },
  controller,
  template: require('./payment-method.html')
};



// WEBPACK FOOTER //
// src/app/buy/payment-method/payment-method.component.ts